import React from 'react'
import ShopfloFooter from 'public/images/logos/shopflo-footer.svg'
import ShopfloLogoBlack from 'public/images/logos/shopflo-logo-black.svg'
import { useLocale } from 'src/lib/hooks/useLocal'

const AuthLayoutV2 = ({ children }: { children: React.ReactNode }) => {
  const { t } = useLocale()
  return (
    <div className='fixed inset-0 flex flex-col bg-zinc-50 justify-center items-center overflow-hidden'>
      <div className='flex mt-12 md:mt-36 items-center w-full h-full flex-col gap-16'>
        <ShopfloLogoBlack />
        {children}
      </div>
      <div className='p-5 flex gap-40 items-center'>
        <div className='max-w-[7rem]'>
          <ShopfloFooter />
        </div>
        <p className='text-text-xxs-medium text-zinc-500 min-w-[7rem]'>{t('login_page.copyright')}</p>
      </div>
    </div>
  )
}

export default AuthLayoutV2
